export const policyStatuses = {
  Active: 0,
  Pending_Cancel: 1,
  Cancelled: 2,
  Expired: 3,
  Renewing: 4,
  Renewed: 5,
  Reinstated: 6,
  Replaced: 7,
  NonRenewal: 8,
  Reinstating: 9,
  Rewriting: 10,
  Rewritten: 11,
};
